import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import Logo from "./Logo";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-stoel-line/60 mt-32 bg-stoel-paperDeep/40"
    >
      <div className="stoel-container py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 text-stoel-ink">
            <Logo size="footer" />
            <div className="text-3xl md:text-4xl font-light tracking-tight text-stoel-ink">
              DeStoel.com
            </div>
          </div>
          <p className="mt-3 text-sm text-stoel-inkSoft max-w-sm leading-relaxed">
            {t.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="stoel-eyebrow mb-4">{t.footer.contact}</div>
          <ul className="space-y-2 text-sm">
            <li>
              <a
                href="mailto:info@destoel.com"
                data-testid="footer-mail-info"
                className="stoel-link text-stoel-ink"
              >
                info@destoel.com
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="stoel-eyebrow mb-4">{t.footer.navigate}</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="stoel-link text-stoel-ink" to="/klassiekers">{t.nav.classics}</Link></li>
            <li><Link className="stoel-link text-stoel-ink" to="/ruimtes">{t.nav.rooms}</Link></li>
            <li><Link className="stoel-link text-stoel-ink" to="/aanpak">{t.nav.approach}</Link></li>
            <li><Link className="stoel-link text-stoel-ink" to="/contact">{t.nav.contact}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stoel-line/40">
        <div className="stoel-container py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-stoel-inkSoft">
          <span>© {year} DeStoel.com. {t.footer.rights}.</span>
          <span className="tracking-wider uppercase">destoel.com</span>
        </div>
      </div>
    </footer>
  );
}
